<app-form-input [label]="" [name]="getUid() + '_SepSep_TypeResultatAttribution_SepAtt_attribue'"
    [parentForm]="parentForm" [disabled]="disabled" [type]="'radio'" [rule]="''" [radios]="[
        {
            value: attribue,
            label: step5.getattribue
        },
        {
            value: infructueux,
            label: step5.getinfructueux
        },
        {
            value: sansSuite,
            label: step5.getsanssuite
        }
        ]" [value]="radioButtonValue">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="lotMarche.numLot" [label]="step5.getnumlot"
    [type]="'text'" [rule]="'required|minSize_1|maxSize_255'" [errorMessage]="{'required' : 'ctr_150'}" [name]="getUid() + '_SepAtt_numLot'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="lotMarche.description"
    [label]="step5.getdescription" [type]="'text'" [rule]="'required|minSize_5|maxSize_2000'" [errorMessage]="{'required' : 'ctr_462'}" [name]="getUid() + '_SepAtt_description'">
</app-form-input>
<app-type-resultat-attribution *ngIf="getResultatAttribution() === attribue" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [resultat]="lotMarche.resultat" [type]="getResultatAttribution()" [index]="index"></app-type-resultat-attribution>
